module.exports = __webpack_public_path__ + "static/media/overachievers-anonymous.46b8be0f.png";